import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CredentialVerification } from './../../../../shared/models/products/credential-verification';
import { Exam } from './../../../../shared/models/products/exam';
import { OtherProduct } from './../../../../shared/models/products/other-product';
import { IProduct } from './../../../../shared/models/products/product';
import { Renewal } from './../../../../shared/models/products/renewal';
import { UserService } from './../../../../../shared/services/user.service';

import { PurchaseStateService } from './../../../../shared/services/purchase-state.service';

enum ProductTypes {
  Credential,
  Exam,  
  OtherProduct,
  Renewal
}

@Component({
  selector: 'app-product-row',
  templateUrl: './product-row.component.html',
  styleUrls: ['./product-row.component.css'],
  host: {'class': 'cart-item'}
})
export class ProductRowComponent implements OnInit {
  productTypes = ProductTypes;

  @Input() product: any;
  @Input() canRemove = true;
  @Output() remove = new EventEmitter<IProduct>();

  get productType() {
    if (!this.product || !this.product.constructor) {return null;}
    
    switch (this.product.constructor) {
      case CredentialVerification:
        return ProductTypes.Credential;
      case Exam:
        return ProductTypes.Exam;
      case OtherProduct:
        return ProductTypes.OtherProduct;
      case Renewal:
        return ProductTypes.Renewal;
      default:
        return null;
    }
  }

  constructor(private purchaseStateService: PurchaseStateService, private userService: UserService) { 
    this.productTypes = ProductTypes;
  }

  isExpired(): boolean {
    if(this.userService.CurrentUser.hasExpiredCredentials && !this.userService.CurrentUser.credentialHolder) {
      return true;
    }
    return false;
  }

  get effectivePrice(){
    const ep = this.purchaseStateService.getEffectiveProductPrice(this.product);
    return ep;
  }

  get basePrice(){
    const bp = this.purchaseStateService.getBaseProductPrice(this.product);
    return bp;
  }

  ngOnInit() {    
  }

  onRemove() {
    this.remove.emit(this.product);
  }
}
